import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuCountryAppResource from './LuCountryAppResource';

export const AL = 11010; // Alabama
export const AK = 11011; // Alaska
export const AZ = 11012; // Arizona
export const AR = 11013; // Arkansas
export const CA = 11014; // California
export const CO = 11015; // Colorado
export const CT = 11016; // Connecticut
export const DE = 11017; // Delaware
export const FL = 11018; // Florida
export const GA = 11019; // Georgia
export const HI = 11020; // Hawaii
export const ID = 11021; // Idaho
export const IL = 11022; // Illinois
export const IN = 11023; // Indiana
export const IA = 11024; // Iowa
export const KS = 11025; // Kansas
export const KY = 11026; // Kentucky
export const LA = 11027; // Louisiana
export const ME = 11028; // Maine
export const MD = 11029; // Maryland
export const MA = 11030; // Massachusetts
export const MI = 11031; // Michigan
export const MN = 11032; // Minnesota
export const MS = 11033; // Mississippi
export const MO = 11034; // Missouri
export const MT = 11035; // Montana
export const NE = 11036; // Nebraska
export const NV = 11037; // Nevada
export const NH = 11038; // New Hampshire
export const NJ = 11039; // New Jersey
export const NM = 11040; // New Mexico
export const NY = 11041; // New York
export const NC = 11042; // North Carolina
export const ND = 11043; // North Dakota
export const OH = 11044; // Ohio
export const OK = 11045; // Oklahoma
export const OR = 11046; // Oregon
export const PA = 11047; // Pennsylvania
export const RI = 11048; // Rhode Island
export const SC = 11049; // South Carolina
export const SD = 11050; // South Dakota
export const TN = 11051; // Tennessee
export const TX = 11052; // Texas
export const UT = 11053; // Utah
export const VT = 11054; // Vermont
export const VA = 11055; // Virginia
export const WA = 11056; // Washington
export const WV = 11057; // West Virginia
export const WI = 11058; // Wisconsin
export const WY = 11059; // Wyoming

export const ALL = {
    AL,// Alabama
    AK, // Alaska
    AZ, // Arizona
    AR,// Arkansas
    CA, // California
    CO, // Colorado
    CT, // Connecticut
    DE, // Delaware
    FL, // Florida
    GA, // Georgia
    HI,// Hawaii
    ID,// Idaho
    IL,// Illinois
    IN, // Indiana
    IA, // Iowa
    KS, // Kansas
    KY,// Kentucky
    LA, // Louisiana
    ME,// Maine
    MD, // Maryland
    MA, // Massachusetts
    MI, // Michigan
    MN, // Minnesota
    MS, // Mississippi
    MO,// Missouri
    MT,// Montana
    NE, // Nebraska
    NV, // Nevada
    NH, // New Hampshire
    NJ, // New Jersey
    NM,// New Mexico
    NY, // New York
    NC, // North Carolina
    ND,// North Dakota
    OH,// Ohio
    OK, // Oklahoma
    OR, // Oregon
    PA, // Pennsylvania
    RI, // Rhode Island
    SC,// South Carolina
    SD,// South Dakota
    TN,// Tennessee
    TX, // Texas
    UT, // Utah
    VT, // Vermont
    VA, // Virginia
    WA, // Washington
    WV, // West Virginia
    WI, // Wisconsin
    WY, // Wyoming
};

export const STATES =  [
    {
        'id': 11010,
        'code': 'al',
        'name': 'Alabama'
    },
    {
        'id': 11011,
        'code': 'ak',
        'name': 'Alaska'
    },
    {
        'id': 11012,
        'code': 'az',
        'name': 'Arizona'
    },
    {
        'id': 11013,
        'code': 'ar',
        'name': 'Arkansas'
    },
    {
        'id': 11014,
        'code': 'ca',
        'name': 'California'
    },
    {
        'id': 11015,
        'code': 'co',
        'name': 'Colorado'
    },
    {
        'id': 11016,
        'code': 'ct',
        'name': 'Connecticut'
    },
    {
        'id': 11017,
        'code': 'de',
        'name': 'Delaware'
    },
    {
        'id': 11018,
        'code': 'fl',
        'name': 'Florida'
    },
    {
        'id': 11019,
        'code': 'ga',
        'name': 'Georgia'
    },
    {
        'id': 11020,
        'code': 'hi',
        'name': 'Hawaii'
    },
    {
        'id': 11021,
        'code': 'id',
        'name': 'Idaho'
    },
    {
        'id': 11022,
        'code': 'il',
        'name': 'Illinois'
    },
    {
        'id': 11023,
        'code': 'in',
        'name': 'Indiana'
    },
    {
        'id': 11024,
        'code': 'ia',
        'name': 'Iowa'
    },
    {
        'id': 11025,
        'code': 'ks',
        'name': 'Kansas'
    },
    {
        'id': 11026,
        'code': 'ky',
        'name': 'Kentucky'
    },
    {
        'id': 11027,
        'code': 'la',
        'name': 'Louisiana'
    },
    {
        'id': 11028,
        'code': 'me',
        'name': 'Maine'
    },
    {
        'id': 11029,
        'code': 'md',
        'name': 'Maryland'
    },
    {
        'id': 11030,
        'code': 'ma',
        'name': 'Massachusetts'
    },
    {
        'id': 11031,
        'code': 'mi',
        'name': 'Michigan'
    },
    {
        'id': 11032,
        'code': 'mn',
        'name': 'Minnesota'
    },
    {
        'id': 11033,
        'code': 'ms',
        'name': 'Mississippi'
    },
    {
        'id': 11034,
        'code': 'mo',
        'name': 'Missouri'
    },
    {
        'id': 11035,
        'code': 'mt',
        'name': 'Montana'
    },
    {
        'id': 11036,
        'code': 'ne',
        'name': 'Nebraska'
    },
    {
        'id': 11037,
        'code': 'nv',
        'name': 'Nevada'
    },
    {
        'id': 11038,
        'code': 'nh',
        'name': 'New Hampshire'
    },
    {
        'id': 11039,
        'code': 'nj',
        'name': 'New Jersey'
    },
    {
        'id': 11040,
        'code': 'nm',
        'name': 'New Mexico'
    },
    {
        'id': 11041,
        'code': 'ny',
        'name': 'New York'
    },
    {
        'id': 11042,
        'code': 'nc',
        'name': 'North Carolina'
    },
    {
        'id': 11043,
        'code': 'nd',
        'name': 'North Dakota'
    },
    {
        'id': 11044,
        'code': 'oh',
        'name': 'Ohio'
    },
    {
        'id': 11045,
        'code': 'ok',
        'name': 'Oklahoma'
    },
    {
        'id': 11046,
        'code': 'or',
        'name': 'Oregon'
    },
    {
        'id': 11047,
        'code': 'pa',
        'name': 'Pennsylvania'
    },
    {
        'id': 11048,
        'code': 'ri',
        'name': 'Rhode Island'
    },
    {
        'id': 11049,
        'code': 'sc',
        'name': 'South Carolina'
    },
    {
        'id': 11050,
        'code': 'sd',
        'name': 'South Dakota'
    },
    {
        'id': 11051,
        'code': 'tn',
        'name': 'Tennessee'
    },
    {
        'id': 11052,
        'code': 'tx',
        'name': 'Texas'
    },
    {
        'id': 11053,
        'code': 'ut',
        'name': 'Utah'
    },
    {
        'id': 11054,
        'code': 'vt',
        'name': 'Vermont'
    },
    {
        'id': 11055,
        'code': 'va',
        'name': 'Virginia'
    },
    {
        'id': 11056,
        'code': 'wa',
        'name': 'Washington'
    },
    {
        'id': 11057,
        'code': 'wv',
        'name': 'West Virginia'
    },
    {
        'id': 11058,
        'code': 'wi',
        'name': 'Wisconsin'
    },
    {
        'id': 11059,
        'code': 'wy',
        'name': 'Wyoming'
    },
];

/**
 * type ValueType = 'id' | 'code' | 'name';
 *
 * @param value {string|number}
 * @param to {string}
 * @param from {?string}
 * @returns {string}
 */
export function stateValueTo(value, to, from = null) {
    if (!from) {
        let x = parseFloat(value);

        switch (true) {
            case Boolean(!isNaN(value) && (x | 0) === x):
                from = 'id';
                break;
            case Boolean(typeof value === 'string' && value.length === 2):
                from = 'code';
                break;
            default:
                from = 'name';
        }
    }

    return STATES.find(
        (state) => value?.toLowerCase() === state[from]?.toLowerCase()
    )?.[to] || value;
}

class LuStateAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-state';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/states';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'slug',
            'title',
            'description',
            'countryId',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            country: LuCountryAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            country: 'country_id',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            slug: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default LuStateAppResource;
